
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auctions/charity/schedule",
      function () {
        return require("private-next-pages/auctions/charity/schedule.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auctions/charity/schedule"])
      });
    }
  